module.exports = __webpack_public_path__ + "img/ewm.1b1ec43c.jpg";